module.exports = __webpack_public_path__ + "static/media/minus-solid.db15fec0.svg";